// extracted by mini-css-extract-plugin
export default {"swipe_up":"swipeUp_swipe_up__axl4v"};